<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block" style="margin: 20px;">
        <div class="document-block mt-2">
            <div class="formSection">
                <div class="head">
                    <strong>Sale Report (Sale Associates-Client Wise)</strong>
                </div>
                <table>
                    <!-- #region Agent Table -->
                    <tr>
                        <th></th>
                        <th>Sr. No.</th>
                        <th (click)="sortData('agentName', 'source')" style="cursor:pointer">Associates Name
                            <span *ngIf="sortField==='agentName' && sortDirection==='asc'">▲</span>
                            <span *ngIf="sortField==='agentName' && sortDirection==='desc'">▼</span>
                        </th>
                        <th (click)="sortData('unitsBooked', 'source')" style="cursor:pointer">Booked Units
                            <span *ngIf="sortField==='unitsBooked' && sortDirection==='asc'">▲</span>
                            <span *ngIf="sortField==='unitsBooked' && sortDirection==='desc'">▼</span>
                        </th>
                        <th (click)="sortData('unitsAllotted', 'source')" style="cursor:pointer">Allotted Units
                            <span *ngIf="sortField==='unitsAllotted' && sortDirection==='asc'">▲</span>
                            <span *ngIf="sortField==='unitsAllotted' && sortDirection==='desc'">▼</span>
                        </th>
                        <th (click)="sortData('amountOfSoldUnits', 'source')" style="cursor:pointer">₹ - Sold Units
                            <span *ngIf="sortField==='amountOfSoldUnits' && sortDirection==='asc'">▲</span>
                            <span *ngIf="sortField==='amountOfSoldUnits' && sortDirection==='desc'">▼</span>
                        </th>
                        <th (click)="sortData('amountReceived', 'source')" style="cursor:pointer">₹ Received
                            <span *ngIf="sortField==='amountReceived' && sortDirection==='asc'">▲</span>
                            <span *ngIf="sortField==='amountReceived' && sortDirection==='desc'">▼</span>
                        </th>
                        <th>% ₹ Received</th>
                        <th (click)="sortData('amountBalance', 'source')" style="cursor:pointer">₹ Balanced
                            <span *ngIf="sortField==='amountBalance' && sortDirection==='asc'">▲</span>
                            <span *ngIf="sortField==='amountBalance' && sortDirection==='desc'">▼</span>
                        </th>
                    </tr>
                    <ng-container *ngIf="saleList?.length > 0">
                        <ng-container *ngFor="let catSale of saleList[0]?.sources; let i = index;">
                            <tr>
                                <td (click)="toggleRow(i)" style="cursor:pointer; text-align:center;">
                                    <span *ngIf="expandedRow !== i">➕</span>
                                    <span *ngIf="expandedRow === i">➖</span>
                                </td>
                                <td><strong>{{i+1}}</strong></td>
                                <td><strong>{{catSale?.agentName}}</strong></td>
                                <td><strong>{{catSale?.unitsBooked}}</strong></td>
                                <td><strong>{{catSale?.unitsAllotted}}</strong></td>
                                <td class="numeric"><strong>{{catSale?.amountOfSoldUnits | indianCurrency:0}}</strong>
                                </td>
                                <td class="numeric"><strong>{{catSale?.amountReceived | indianCurrency:0}}</strong></td>
                                <td class="numeric"><strong>{{ (catSale?.amountReceived /catSale?.amountOfSoldUnits
                                        )*100 |
                                        number:'1.0-0'}} %</strong></td>
                                <td class="numeric"><strong>{{catSale?.amountBalance | indianCurrency:0}}</strong>
                                </td>

                            </tr>
                            <!-- Expanding Source/agent Row -->
                            <tr [hidden]="expandedRow !== i">
                                <td colspan="9">
                                    <div class="scrollable-nested">
                                        <table class="nested-table">
                                            <tr>
                                                <th></th>
                                                <th>Sr. No.</th>
                                                <th (click)="sortData('clientName', 'client', i)">Client Name
                                                    <span
                                                        *ngIf="sortField==='clientName' && sortDirection==='asc'">▲</span>
                                                    <span
                                                        *ngIf="sortField==='clientName' && sortDirection==='desc'">▼</span>
                                                </th>
                                                <th (click)="sortData('unitsBooked', 'client')" style="cursor:pointer">
                                                    Booked Units
                                                    <span
                                                        *ngIf="sortField==='unitsBooked' && sortDirection==='asc'">▲</span>
                                                    <span
                                                        *ngIf="sortField==='unitsBooked' && sortDirection==='desc'">▼</span>
                                                </th>
                                                <th (click)="sortData('unitsAllotted', 'client')"
                                                    style="cursor:pointer">
                                                    Allotted Units
                                                    <span
                                                        *ngIf="sortField==='unitsAllotted' && sortDirection==='asc'">▲</span>
                                                    <span *ngIf="sortField==='unitsAllotted' && sortDirection==='desc'">
                                                        ▼</span>
                                                </th>
                                                <th (click)="sortData('amountOfSoldUnits','client')"
                                                    style="cursor:pointer">
                                                    ₹ - Sold Units
                                                    <span
                                                        *ngIf="sortField==='amountOfSoldUnits' && sortDirection==='asc'">▲</span>
                                                    <span
                                                        *ngIf="sortField==='amountOfSoldUnits' && sortDirection==='desc'">▼</span>
                                                </th>
                                                <th (click)="sortData('amountReceived', 'client')"
                                                    style="cursor:pointer">₹
                                                    Received
                                                    <span
                                                        *ngIf="sortField==='amountReceived' && sortDirection==='asc'">▲</span>
                                                    <span
                                                        *ngIf="sortField==='amountReceived' && sortDirection==='desc'">▼</span>
                                                </th>
                                                <th>% ₹ Received</th>
                                                <th (click)="sortData('amountBalance','client')" style="cursor:pointer">
                                                    ₹
                                                    Balanced
                                                    <span
                                                        *ngIf="sortField==='amountBalance' && sortDirection==='asc'">▲</span>
                                                    <span
                                                        *ngIf="sortField==='amountBalance' && sortDirection==='desc'">▼
                                                    </span>
                                                </th>
                                            </tr>
                                            <ng-container *ngFor="let client of catSale?.clients; let j = index;">
                                                <tr>
                                                    <td (click)="toggleClientRow(j)"
                                                        style="cursor:pointer; text-align:center;">
                                                        <span *ngIf="expandedClientRow !== j">➕</span>
                                                        <span *ngIf="expandedClientRow === j">➖</span>
                                                    </td>
                                                    <td><strong>{{i+1}}.{{j+1}}</strong></td>
                                                    <td><strong>{{client?.clientName}}</strong></td>
                                                    <td><strong>{{client?.unitsBooked}}</strong></td>
                                                    <td><strong>{{client?.unitsAllotted}}</strong></td>
                                                    <td class="numeric"><strong>{{client?.amountOfSoldUnits |
                                                            indianCurrency:0}}</strong></td>
                                                    <td class="numeric"><strong>{{client?.amountReceived |
                                                            indianCurrency:0}}</strong></td>
                                                    <td class="numeric"><strong>{{ (client?.amountReceived
                                                            /client?.amountOfSoldUnits)*100 | number:'1.0-0'}}
                                                            %</strong>
                                                    </td>
                                                    <td class="numeric"><strong>{{client?.amountBalance |
                                                            indianCurrency:0}}</strong>
                                                    </td>
                                                </tr>
                                                <!-- Expanding Client Row -->
                                                <tr [hidden]="expandedClientRow !== j">
                                                    <td colspan="9">
                                                        <div class="scrollable-nested-client">
                                                            <table class="nested-table-client">
                                                                <tr>
                                                                    <th>Sr. No.</th>
                                                                    <th (click)="sortData('type', 'transaction', i)">
                                                                        Sale
                                                                        Type
                                                                        <span
                                                                            *ngIf="sortField==='type' && sortDirection==='asc'">▲</span>
                                                                        <span
                                                                            *ngIf="sortField==='type' && sortDirection==='desc'">▼</span>
                                                                    </th>
                                                                    <th>Size</th>
                                                                    <th
                                                                        (click)="sortData('bookingDate', 'transaction', i)">
                                                                        Booking Date
                                                                        <span
                                                                            *ngIf="sortField==='bookingDate' && sortDirection==='asc'">▲</span>
                                                                        <span
                                                                            *ngIf="sortField==='bookingDate' && sortDirection==='desc'">▼</span>
                                                                    </th>
                                                                    <th>₹ - Sold Units</th>
                                                                    <th>₹ Received</th>
                                                                    <th>% ₹ Received</th>
                                                                    <th>₹ Balanced</th>
                                                                </tr>
                                                                <ng-container
                                                                    *ngFor="let unit of client?.transactions; let k = index;">
                                                                    <tr>
                                                                        <td><strong>{{i+1}}.{{j+1}}.{{k+1}}</strong>
                                                                        </td>
                                                                        <td><strong>{{unit?.type}}</strong></td>
                                                                        <td><strong>{{unit?.size}}</strong></td>
                                                                        <td><strong>{{unit?.bookingDate |
                                                                                date:'dd-MM-yyyy'}}</strong></td>
                                                                        <td class="numeric">
                                                                            <strong>{{unit?.amountOfSoldUnits |
                                                                                indianCurrency:0}}</strong>
                                                                        </td>
                                                                        <td class="numeric">
                                                                            <strong>{{unit?.amountReceived |
                                                                                indianCurrency:0}}</strong>
                                                                        </td>
                                                                        <td class="numeric"><strong>{{
                                                                                (unit?.amountReceived
                                                                                /unit?.amountOfSoldUnits)*100 |
                                                                                number:'1.0-0'
                                                                                }} %</strong></td>
                                                                        <td class="numeric">
                                                                            <strong>{{unit?.amountBalance |
                                                                                indianCurrency:0}}</strong>
                                                                        </td>
                                                                    </tr>
                                                                </ng-container>
                                                            </table>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                    <!-- #endregion Agent Table -->
                    <!-- #region Summary Row -->
                    <tr>
                        <th colspan="3">Total</th>
                        <th>{{ saleList?.length > 0 ? saleList[0]?.totalBooked : 0 }}</th>
                        <th>{{ saleList?.length > 0 ? saleList[0]?.totalAllotments : 0}}</th>
                        <th class="numeric">{{saleList?.length > 0 ? saleList[0]?.soldValue :0 | indianCurrency:0 }}
                        </th>
                        <th class="numeric">{{ saleList?.length > 0 ? saleList[0]?.receivedAmount : 0 | indianCurrency:0
                            }}</th>
                        <th class="numeric">{{ ((saleList?.length > 0 ? saleList[0]?.receivedAmount : 0)
                            /(saleList?.length > 0 ? saleList[0]?.soldValue : 0))*100 |
                            number:'1.0-0'}} %</th>
                        <th class="numeric">{{ saleList?.length > 0 ? saleList[0]?.soldValue :0 -
                            saleList?.length > 0 ? saleList[0]?.receivedAmount :0 | indianCurrency:0
                            }}</th>
                    </tr>
                    <!-- #endregion Summary Row -->
                </table>
            </div>
        </div>
    </div>